import React, { Component } from 'react';
import './Contact.scss';

function validateEmail(email) {
    //const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //return re.test( email.trim() );
    return true;
}

export default class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sent: false,
      email: '',
      name: '',
      content: '',
      subject: 'Resume Contact Request'
    };
  }

  handleSubmit(event)  {
    event.preventDefault();

    const form = this;
    const email = $(form.refs.email).val().trim();;

    if (validateEmail(email)) {
      // clear out email valiation message
      $(form.refs.feedback).removeClass('error');
      $(form.refs.feedback).text('');

      // submit the form via ajax
      let data = {
        email: email,
        name: $(form.refs.name).val(),
        message: $(form.refs.message).val()
      };

      $.ajax({
        url: 'https://vip.retail-ex.com/services/users/contact',
        type: 'POST',
        data: data

      })
      .done( function(msg){
        //console.log('post done: ' + msg);
        $(form.refs.feedback).text(msg);

        if (msg.startsWith("Error")) {
          $(form.refs.feedback).removeClass('success');
          $(form.refs.feedback).addClass('error');

        } else {
          $(form.refs.feedback).removeClass('error');
          $(form.refs.feedback).addClass('success');

          $(form.refs.email).val('');
          $(form.refs.name).val('');
          $(form.refs.message).val('');
        }
      })
      .fail( function(xhr) {
        //console.log('error:');
        //console.log(xhr);
        $(form.refs.feedback).text('There was an error; please try again later');
        $(form.refs.feedback).addClass('error');
      });

    } else {
        $(form.refs.feedback).text('Please enter a valid email address');
        $(form.refs.feedback).addClass('error');
    }
  }

  render() {
    return (
      <section id="contact" className="section contact-us">
        <div className="container">
          <div className="section-title">
            <h2>Contact<span> Me</span></h2>
          </div>
          <div className="row">
            <div className="col-sm-6 col-xs-12 col-md-6 col-md-offset-1">
              <div className="contact-form">
              <form id="contact_form">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="sr-only">Name</label>
                      <input className="form-control"ref="name" name="name" placeholder="Name" type="text" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="sr-only">Email</label>
                      <input className="form-control" ref="email" name="email" placeholder="Email" type="email" required="required" />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group contact-message">
                      <label className="sr-only">Your message</label>
                      <textarea className="form-control" ref="message" name="message" rows="4" placeholder="Your message" required="required"></textarea>
                      <div ref="feedback" className="contact-feedback"></div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group action">
                      <button className="m-btn" onClick={this.handleSubmit.bind(this)}>SEND MESSAGE</button>
                    </div>
                  </div>
                </div>

              </form>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 col-xs-12">
              <div className="contact-info">
                  <i className="fa fa-envelope"></i>
                  <h4>Email:</h4>
                  <p><a href="mailto:willoughby.d@gmail.com">willoughby.d@gmail.com</a></p>
              </div>
              <div className="contact-info">
                  <i className="fa fa-phone"></i>
                  <h4>Phone:</h4>
                  <p>617-335-9393</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Contact.js